import React from 'react';
import { Container, Row, Col } from 'react-bootstrap';
import FAQTabs from './FAQTabs'; // Aynı FAQTabs bileşeni
import './FAQPage.css';

const FAQPage = () => {
    return (
        <div className="faq-page py-5">
            <Container>
                <Row className="mb-4">
                    <Col lg={12} className="text-center">
                        <h1 className="page-title mb-2">Sık Sorulan Sorular</h1>
                        <div className="title-underline mb-4"></div>
                        <p className="lead">
                            Otoprime hakkında merak ettiğiniz tüm soruların cevaplarını bu sayfada bulabilirsiniz.
                        </p>
                    </Col>
                </Row>

                {/* FAQTabs'ı kendi başlığını göstermeden kullanıyoruz, çünkü yukarıda zaten başlık var */}
                <FAQTabs showTitle={false} />

                <Row className="justify-content-center mt-5">
                    <Col lg={8} className="text-center">
                        <div className="faq-contact-box p-4 shadow-sm rounded">
                            <h4>Aradığınız sorunun cevabını bulamadınız mı?</h4>
                            <p>Merak ettiğiniz diğer sorular için bizimle iletişime geçebilirsiniz.</p>
                            <div className="d-flex justify-content-center gap-3">
                                <a href="/contact" className="btn btn-primary">İletişime Geç</a>
                                <a href="tel:+905323873091" className="btn btn-outline-primary">Ara: 0532 387 3091</a>
                            </div>
                        </div>
                    </Col>
                </Row>
            </Container>
        </div>
    );
};

export default FAQPage;